<template lang="html" >
    <div class="sidebar scrollbar"  >
        <el-row class="tac">
         <el-scrollbar style="height:100%">
            <el-col :span="16" class="menu-side">
               <div>
                <img class="sidebar-logo" src="static/img/verifone_logo.png">
                <div class="admin-name">
                 <span class="resellerName">{{adminName}}</span>
                </div>
                </div>
              <!--   <h4 class="menu-title">Application Marketplace</h4>-->
              <el-menu router :default-active="$route.path" :unique-opened="true" class="el-menu-vertical-demo sidebar-item" background-color="#3a73d9" text-color="#fff" active-text-color="#fff">
                <el-menu-item index="/dashboard">
                    <img class="dashboard-icon" src="static/img/dashboard.png" alt="">
                    <!-- <span slot="title">Dashboard</span> -->
                    <span slot="title">{{$t('message.dashboard')}}</span>
                </el-menu-item>
                <el-menu-item index="/appManagement" v-show="appShow">
                    <img class="sidebar-icon" src="static/img/app.png" alt="">
                    <span slot="title">{{$t('message.app')}}</span>
                </el-menu-item>
                <el-submenu index="3" v-show="downloadShow">
                    <template slot="title">
                        <img class="sidebar-icon" src="static/img/download.png" alt="">
                        <span>{{$t('message.download')}}</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/downloadList">
                            <span>{{$t('message.downloadTasks')}}</span>
                        </el-menu-item>
                        <el-menu-item v-show="createShow" index="/createDownload">
                            <span>{{$t('message.createTaskMenu')}}</span>
                        </el-menu-item>
                        <el-menu-item v-show="createShow" index="/createDelete">
                            <span>{{$t('message.downloadDelete')}}</span>
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu index="4" v-show="merchantGroup">
                    <template slot="title">
                        <img class="sidebar-icon" src="static/img/merchant.png" alt="">
                        <span>{{$t('message.merchant')}}</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/merchantlist" v-show="merchantShow"><p>{{$t('message.merchantManage')}}</p></el-menu-item>
                        <el-menu-item index="/grouplist" v-show="groupShow"><p>{{$t('message.groupManage')}}</p></el-menu-item>
                        <!-- <el-menu-item index="/functionList" v-show="functionShow"><p>{{$t('message.functionManage')}}</p></el-menu-item>//功能不需要，暂时隐藏 -->
                    </el-menu-item-group>
                </el-submenu>
                <el-menu-item index="/terminalList" v-show="terminalShow">
                    <img class="sidebar-icon" src="static/img/terminal.png" alt="">
                    <span slot="title">{{$t('message.terminal')}}</span>
                </el-menu-item>
                <!--<el-menu-item index="/diagnosticList" v-show="diagnosticShow">
                    <img class="sidebar-icon" src="static/img/diagnostic.png" alt="">
                    <span slot="title">{{$t('message.diagnostic')}}</span>
                </el-menu-item>-->
                <el-submenu index="5" v-show="alertShow">
                    <template slot="title">
                        <img class="sidebar-icon" src="static/img/alert.png" alt="">
                        <span>{{$t('message.alert')}}</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/openAlert"><p>{{$t('message.openAlert')}}</p></el-menu-item>
                        <el-menu-item index="/alertHistory"><p>{{$t('message.alertHistory')}}</p></el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu index="6" v-show="reportShow">
                    <template slot="title">
                        <img class="sidebar-icon" src="static/img/report.png" alt="">
                        <span>{{$t('message.report')}}</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/createTable" v-show="reportCreateShow"><p>{{$t('message.createReport')}}</p> </el-menu-item>
                        <el-menu-item index="/reportDownload" v-show="reportDownloadShow"><p>{{$t('message.reportDownload')}}</p></el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
              <!--  <el-menu-item index="/adminList" v-show="userShow">
                    <img class="sidebar-icon" src="static/img/userMenu.png" alt="">
                    <span slot="title">{{$t('message.users')}}</span>
                </el-menu-item> -->
                <el-submenu index="7" v-show="userShow">
                    <template slot="title">
                        <img class="sidebar-icon" src="static/img/userMenu.png" alt="">
                        <span>{{$t('message.systemManage')}}</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/adminList"  v-show="userShow"><p>{{$t('message.users')}}</p> </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
            </el-menu>
        </el-col>
       </el-scrollbar>
    </el-row>

</div>
</template>

<script>
export default {
    data() {
        return {
            adminName:'',
            role: null,
            appShow: false,
            downloadShow: false,
            merchantShow: false,
            terminalShow: false,
            diagnosticShow: false,
            alertShow: false,
            userShow: false,
            merchantGroup: false,
            groupShow: false,
            createShow: false,
            reportShow: false,
            reportCreateShow: false,
            reportDownloadShow:false,
            functionShow:false,
        }
    },
    mounted() {
      this.setRole();
      this.setAdmin();
    },
	methods: {
    setAdmin() {
      this.adminName = sessionStorage.getItem('verifoneResellerName');
       console.log( "roleList:"+sessionStorage.getItem('verifoneRoleList'));
    },
        setRole() {
            let role = sessionStorage.getItem('verifoneRoleList').split(',').map(str => parseInt(str));

            this.merchantShow = role.indexOf(10) == -1 && role.indexOf(11) == -1 ? false : true;
            this.groupShow = role.indexOf(20) == -1 ? false : true;
            this.appShow = role.indexOf(30) == -1 && role.indexOf(31) == -1 ? false : true;
            this.terminalShow = role.indexOf(40) == -1 && role.indexOf(41) == -1 ? false : true;
            this.downloadShow = role.indexOf(50) == -1 && role.indexOf(51) == -1 ? false : true;
            this.diagnosticShow = role.indexOf(60) == -1 ? false : true;
            this.alertShow = role.indexOf(70) == -1 && role.indexOf(71) == -1 ? false : true;
            this.userShow = role.indexOf(80) == -1 ? false : true;
            this.createShow = role.includes(51) ? false : true;
            this.reportCreateShow = role.indexOf(90) == -1 ? false : true;
            this.reportDownloadShow = role.indexOf(100) == -1 ? false : true;
            this.functionShow = role.indexOf(110) == -1 ? false:true;
            this.merchantGroup = this.merchantShow || this.groupShow;
            this.reportShow = this.reportCreateShow || this.reportDownloadShow;
        }
    }
}
</script>

<style lang="css">
.sidebar-logo {
    width: 150px;
    height: auto;
    margin: 0 0 -30px 10px;
}
.admin-name{
  heigth:80px;
  margin: 10px 10px 30px 20px ;
}
.resellerName{
  color:#ffffff ;
}
.sidebar-item {
    border-right: 1px solid #3a73d9;
}
.sidebar-item span {
    font-size: 15px!important;
    font-weight: 400;
    font-family: 'Arial';
}
.sidebar-item p {
    font-size: 14px;
    font-weight: 500;
    font-family: 'Arial';
}
.menu-side {
    width: 220px;
}
.menu-title {
    color: #fff;
    margin: 0 10px 40px 17px;
    font-family: 'Arial';
    font-weight: 100;
}
.is-active {
    background-color: #315fc1!important;
    color: #fff!important;
}
a {
    color: #101010;
    text-decoration: none;
}
.el-menu-item {
    padding-left: 30px;
}
.el-menu-item.is-active {
    color: #fff!important;
}
.sidebar-icon, .dashboard-icon {
    width: 20px;
    height: 20px;
}
.el-menu-item, .el-submenu__title {
    height: 45px;
    line-height: 45px;
}
.el-menu-item-group__title {
    padding: 0;
}

</style>
s



// WEBPACK FOOTER //
// src/components/common/Sidebar.vue